import { render } from "./courseModules.vue?vue&type=template&id=2c82b6bc&scoped=true&ts=true"
import script from "./courseModules.vue?vue&type=script&lang=ts"
export * from "./courseModules.vue?vue&type=script&lang=ts"

import "./courseModules.vue?vue&type=style&index=0&id=2c82b6bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c82b6bc"]])

export default __exports__